/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Badge,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../Styles/genericModal.module.css";
import { useIsMobile } from "../Hooks/useIsMobile";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import { useContext, useEffect, useState } from "react";
import { urlEnum } from "../Utils/urlEnum";
import { postData } from "../Services/postData";
import { updateData } from "../Services/updateData";
import { CacheContext } from "../Context/cacheContext";
import { getData } from "../Services/getData";
import { Note } from "../Models/Models";
import { Vocabulary } from "../Utils/Vocabulary";
type Props = {
  open: boolean;
  onClose: () => void;
  children: any;
  buttons?: any;
  title: string;
  subtitle?: any;
  maxWidth?: any;
  zIndex?: number;
  notes?: any;
  fullScreenOnMobile?: boolean;
};

/** Displays a modal with a title, content, actions, and optional notes. */
function GenericModal(props: Props) {
  const {
    open,
    children,
    zIndex,
    onClose,
    title,
    subtitle,
    maxWidth,
    buttons,
    fullScreenOnMobile,
  } = props;
  const [openModalNotes, setOpenModalNotes] = useState(false);
  const [notes, setNotes]: any = useState(new Note());
  const cacheContext = useContext(CacheContext);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (props.notes && props.notes.entityId) {
      getNotes();
    }
  }, [props.notes?.entityId, props.notes?.entity]);


  /** Loads the note associated with the configured entity. */
  function getNotes() {
    if (!props.notes || !props.notes.entityId) return;

    const url = `${urlEnum.notes}/${props.notes.entityId.toString()}/${
      props.notes.entity
    }`;

    getData(url)
      .then((res: any) => {
        res.data.note === null ? setNotes(new Note()) : setNotes(res.data.note);
      })
      .catch((_: any) => {
        //
      });
  }

  
  /** Saves a new note for the configured entity. */
  function addNewNote() {
    const url = `${urlEnum.notes}`;
    if (notes.note !== "") {
      postData(url, {
        user_id: localStorage.getItem("useId"),
        entity_id: props.notes.entityId.toString(),
        entity: props.notes.entity,
        note: notes.note,
      })
        .then(() => {
          getNotes();
        })
        .catch(() => {
          //
        });
    }
  }

  
  /** Updates the note for the configured entity. */
  function updateNote() {
    const url = `${urlEnum.notes}/${notes.id}`;

    updateData(url, {
      user_id: localStorage.getItem("useId"),
      entity_id: props.notes.entityId.toString(),
      entity: props.notes.entity,
      note: notes.note,
    })
      .then(() => {
        //
      })
      .catch(() => {
        //
      });
  }

  function handleChangeNote(text: any) {
    const newNote = { ...notes };
    newNote.note = text;
    setNotes(newNote);
  }

  return (
    <>
      <Dialog
        // onClose={onClose}
        open={open}
        id="genericModal"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              margin: "7px !important",
              width: "100%",
              maxWidth: maxWidth ? maxWidth : 750,
              overflowY: isMobile ? "auto" : "visible",
              overflowX: isMobile ? "hidden" : "visible",
              zIndex: zIndex ? zIndex : 100,
              position: "sticky",
            },
          },
        }}
        fullScreen={fullScreenOnMobile != false && isMobile}
      >
        <DialogTitle
          style={{ marginBottom: -10, textTransform: "capitalize" }}
          className={styles.dialogTitle}
        >
          {openModalNotes ? (
            <Paper className={styles.notePaper}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p
                  style={{
                    fontSize: 10,
                    fontStyle: "italic",
                    marginBottom: -8,
                  }}
                >
                  {
                    cacheContext.cache.users.find(
                      (user: any) => user.id === parseInt(notes?.user_id)
                    )?.nume
                  }
                </p>
                <IconButton
                  aria-label={openModalNotes ? Vocabulary.closeNote : Vocabulary.openNote}
                  onClick={() => setOpenModalNotes(false)}
                  className={styles.closeIconForNotes}
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </div>
              <TextField
                placeholder={Vocabulary.noteMessage}
                style={{ width: "100%" }}
                id="obsTVA"
                value={notes?.note}
                onChange={(e) => handleChangeNote(e.target.value)}
                size="small"
                onBlur={notes.id ? () => updateNote() : () => addNewNote()}
                variant="outlined"
                multiline
                rows={7}
              />
            </Paper>
          ) : null}

          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <p className={styles.title} style={{ marginBottom: subtitle ? "0.5rem" : undefined }}>{title}</p>
            {subtitle && <div>{subtitle}</div>}
          </div>
          {props.notes ? (
            <p className={styles.notes}>
              {notes?.note ? (
                <Badge badgeContent=" " variant="dot" color="primary">
                  <IconButton
                    aria-label={Vocabulary.closeNote}
                    onClick={() => setOpenModalNotes(!openModalNotes)}
                    size="small"
                  >
                    <SpeakerNotesIcon />
                  </IconButton>
                </Badge>
              ) : (
                <IconButton
                  aria-label={openModalNotes ? Vocabulary.closeNote : Vocabulary.openNote}
                  onClick={() => setOpenModalNotes(!openModalNotes)}
                  size="small"
                >
                  <SpeakerNotesIcon />
                </IconButton>
              )}
            </p>
          ) : null}
          <p className={styles.close}>
            <IconButton
              aria-label={Vocabulary.close}
              onClick={onClose}
              className={styles.closeIcon}
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </p>
        </DialogTitle>
        <DialogContent style={{ overflowY: buttons ? "scroll" : "inherit" }}>
          {children}
        </DialogContent>
        <DialogActions>{buttons}</DialogActions>
      </Dialog>
    </>
  );
}

export default GenericModal;
